export const myOutlookLabel = "tanv0c";
export const outlookTodayLabel = "Garttb";
export const outlookTodayNewBriefingLabel = "AjM1ke";
export const automationsLabel = "IbO4eb";
export const myMirrorLabel = "xR2Jcb";
export default {myOutlookLabel,outlookTodayLabel,outlookTodayNewBriefingLabel,automationsLabel,myMirrorLabel};